<template>
  <div class="shu">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>活动征稿</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img :class="isRefresh ?'imgmove':''" width="16px" height="16px" src="@/assets/house/refresh.png" alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>活动征稿</h4>
      </div>

      <div class="kabj">
        <div v-if="powersObj.checkPictureArticle" :class="isSimple ? 'ka simpleka' : 'ka' " @click="$router.push('/workflow/listPictureActivityArticle')">
          <img width="103" height="103" src="@/assets/platform/11.png" alt="">
          <div class="text">
            <p>投稿审核与入库</p>
            <p style="margin-top: 15px;font-size:14px;color:rgba(52,52,52,1);">您可以通过此工作流浏览所有投稿，并对某个稿件或某个稿件或某张图片进行操作。</p>
            <div class="link" style="width:30%">
              <div :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" @click.stop="$router.push({path:'/workflow/listPictureActivityArticle',query:{status:0}})">待审核</div>
              <div :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" @click.stop="$router.push({path:'/workflow/listPictureActivityArticle',query:{status:1}})">已通过</div>
              <div :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" @click.stop="$router.push({path:'/workflow/listPictureActivityArticle',query:{status:2}})">不通过</div>
            </div>
          </div>
        </div>

        <div v-if="powersObj.myPictureArticleFilter || powersObj.manageAllPictureArticleFilter" :class="isSimple ? 'ka simpleka' : 'ka' " @click="$router.push('/workflow/listTask')">
          <img width="103" height="103" src="@/assets/platform/12.png" alt="">
          <div class="text">
            <p>投稿图片筛选</p>
            <p style="margin-top: 15px;font-size:14px;color:rgba(52,52,52,1);">您可以通过所有活动投稿中包含的图片进行筛选，筛选及审核过程由多人完成。</p>
            <div class="link" style="width:70%">
              <div :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">全部任务</div>
              <div :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" @click.stop="$router.push({path:'/workflow/listTask',query:{id:1}})" v-if="powersObj.myPictureArticleFilter || powersObj.manageAllPictureArticleFilter">我创建的任务</div>
              <div :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}" @click.stop="$router.push({path:'/workflow/listTask',query:{id:2}})">待我审核的任务</div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate,formatConversion } from "@/plugins/getdate";
import { powersObj } from "@/constants/powers";
export default {

  data() {
    return {
      isRefresh:false,
      powersObj,
    };
  },
  methods: {
    
  },
  created() {

  },
  beforeDestroy(){ 
     
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./activitycontribution.scss";

</style>
